<template>
  <v-tooltip
    v-if="!disabled"
    :disabled="hasEmptyTooltip"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <avs-button
        v-bind="{ ...attrs, ...shape, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        color="error"
        iconI="mdi-delete"
        icon
        label
        fab
        small
      />
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
  <avs-button
    v-else
    v-bind="{ ...shape, ...$attrs }"
    v-on="$listeners"
    disabled
    iconI="mdi-delete-off"
    icon
    label
  />
</template>

<script>
export default {
  name: "DeleteButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    shape: {
      type: Object,
      default: () => ({ fab: true, icon: true, small: true })
    },
    spantext: {
      type: String
    }
  },
  computed: {
    hasEmptyTooltip() {
      return !this.spantext
    }
  }
}
</script>
